import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Nearmiss } from './nearMiss.interface';
import { environment } from '../../../environments/environment';
import { buildAnalyticsParams } from '../analytics-params';

@Injectable({
    providedIn: 'root'
  })

export class NearMissService {
    private apiUrl = `${environment.apiConfig.uri}/nearmiss`;
    private apiUrlExport = `${environment.apiConfig.uri}/nearmiss/export`;
    private apiUrlPdf = `${environment.apiConfig.uri}/nearmiss/getPdf`;
    private apiUrlTotals = `${environment.apiConfig.uri}/nearmiss/totals`;
    constructor(private http: HttpClient) {
    }

    createNearMiss(newNearmiss: Nearmiss): Observable<any> {
        return this.http.post(this.apiUrl, {
            dateOfReport: newNearmiss.dateOfReport,
            supervisor: newNearmiss.supervisor,
            office: newNearmiss.office,
            nearMissDate: newNearmiss.nearMissDate,
            time: newNearmiss.time,
            location: newNearmiss.location,
            type: newNearmiss.type,
            equipment: newNearmiss.equipment,
            persons: newNearmiss.persons,
            desc: newNearmiss.desc,
            rate: newNearmiss.rate,
            actions: newNearmiss.actions,
            dateDiscussed: newNearmiss.dateDiscussed,
            completedBy: newNearmiss.completedBy,
            title: newNearmiss.title,
            email: newNearmiss.email
        })
    }

    getNearMissPdfs(): Observable<any> {
        return this.http.get<any>(this.apiUrlPdf);
    }

    getNearMissTotalsByMonth(offices?: string[], startDate?: Date, endDate?: Date): Observable<any> {
        return this.http.get<any>(this.apiUrlTotals, { params: buildAnalyticsParams(offices, startDate, endDate) });
    }

    

    exportNearMissExcel(): Observable<Blob> {
        return this.http.get(this.apiUrlExport, {
            responseType: 'blob'
        })
    }
}
